import { type FC } from 'react';
import { IconButton } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import type { ICellRendererParams } from 'ag-grid-community';

interface MATExpandIconCellProps extends ICellRendererParams {
  onExpandRow: (data: any) => void;
  isExpanded: boolean;
}

const MATExpandIconCell: FC<MATExpandIconCellProps> = ({ data, onExpandRow, isExpanded }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onExpandRow(data);
        }}
        sx={{ padding: '2px' }}
        data-cy="expand-icon"
      >
        {isExpanded ? (
          <KeyboardArrowDownIcon fontSize="small" />
        ) : (
          <KeyboardArrowRightIcon fontSize="small" />
        )}
      </IconButton>
    </div>
  );
};

export default MATExpandIconCell;
